var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';
import { controlModel } from './control.model';

// storage
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';

// constants
import urls from '../../constants/urls.constant';
import { config } from '../../config/apiConfig';

import { getIcon, getSeverityLevel } from '../../services/core/device/device.helper';

// utils
import { dateToTst, dateToMomentDate, roundNumber } from '../../utils/helpers';

import { convertServerDataToModelData, calcEnergySum } from '../../services/core/cost/cost.helper';
import { getInfoByStatus } from '../../services/core/control/control.helper';

//endregion


class deviceModel extends model {
    //region init

    constructor(props) {
        super(props);
    }

    static create() {
        return _extends({}, super.create(), {
            deviceId: '',
            chart: {
                isLoading: false,
                min: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                items: []
            },
            data: {
                isLoading: false
            },
            status: {
                isLoading: false
            },
            power: {
                isLoading: false
            },
            energy: {
                isLoading: false
            },
            changeStatus: {
                isLoading: false
            }
        });
    }

    //endregion
    //region model

    static processServerResponse(dispatch, params, model, serverResponse, history) {}

    static isClientEmpty(clientModel) {
        return !clientModel;
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_REQUEST_DEVICE_DATA]: model.reduceRequestDeviceData.bind(model),
            [model.TYPE_DEVICE_DATA]: model.reduceGetDeviceData.bind(model),

            [model.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA]: model.reduceRequestDeviceEnergyChartData.bind(model),
            [model.TYPE_DEVICE_ENERGY_CHART_DATA]: model.reduceGetDeviceEnergyChartData.bind(model),

            [model.TYPE_REQUEST_DEVICE_STATUS]: model.reduceRequestGetDeviceStatus.bind(model),
            [model.TYPE_DEVICE_STATUS]: model.reduceGetDeviceStatus.bind(model),

            [model.TYPE_REQUEST_DEVICE_POWER]: model.reduceRequestGetDevicePower.bind(model),
            [model.TYPE_DEVICE_POWER]: model.reduceGetDevicePower.bind(model),

            [model.TYPE_REQUEST_DEVICE_ENERGY]: model.reduceRequestGetDeviceEnergy.bind(model),
            [model.TYPE_DEVICE_ENERGY]: model.reduceGetDeviceEnergy.bind(model),

            [model.TYPE_REQUEST_SET_DEVICE_STATUS]: model.reduceRequestSetDeviceStatus.bind(model),
            [model.TYPE_SET_DEVICE_STATUS]: model.reduceSetDeviceStatus.bind(model)

        };

        return reducers[type];
    }

    //endregion
    //region api get device

    static apiGetDeviceData(clientApiMethod, params = {}, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapDeviceDataToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const url = urls.core.getDevice(urlParams);
            const serverUrl = yield settingsGetServerUrl();

            dispatch(_this.actionRequestPayload(_this.TYPE_REQUEST_DEVICE_DATA, {
                deviceId: urlParams.deviceId,
                dataKey: 'data',
                isLoading: true
            }, controlModel));
            dispatch(_this.actionRequest(_this.TYPE_REQUEST_DEVICE_DATA, true, _this));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this.mapDeviceDataToClient(serverResponse);
                dispatch(_this.dispatchModel({ modelClient, model: _this }));
                return serverResponse;
            }).catch(function (error) {
                _this.catchRequest(_this, dispatch, failAction)(error);
                dispatch(_this.actionRequestPayload(_this.TYPE_REQUEST_DEVICE_DATA, {
                    deviceId: urlParams.deviceId,
                    dataKey: 'data',
                    isLoading: false
                }, controlModel));
                dispatch(_this.actionRequest(_this.TYPE_REQUEST_DEVICE_DATA, false, _this));
            });
        })();
    }

    static reduceRequestDeviceData(stateModel, action, state) {
        const { model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                data: _extends({}, stateModel.data, {
                    isLoading: true
                })
            })
        };
    }

    static mapDeviceDataToClient(serverModel) {
        if (!serverModel) {
            return {
                data: {}
            };
        }

        const deviceId = Object.keys(serverModel)[0];
        const value = serverModel[deviceId];

        return {
            deviceId,
            data: {
                circuit_history: value.data.circuit_history,
                enabled: value.data.enabled,
                type: value.data.type,
                analysis: value.data.analysis,
                priority: value.data.priority,
                circuits: value.data.circuits,
                name: value.data.name,
                virtual: value.data.virtual,
                custom: value.data.custom,
                notify: value.data.notify,
                group: value.data.group,
                unit: value.data.unit,
                icon: getIcon(value.data.notify, value.data.type),
                severityLevel: getSeverityLevel(value.data.notify),
                isLoading: false
            },
            time: value.time
        };
    }

    static mapDeviceDataToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {
                deviceId: clientModel.deviceId
            }
        };
    }

    static reduceGetDeviceData(stateModel, action) {
        const { modelClient, model } = action.payload;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }

    //endregion
    //region api get device chart

    static apiGetDeviceEnergyChartData(clientApiMethod, params = {}, dispatch, failAction) {
        var _this2 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this2.mapDeviceEnergyChartDataToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDeviceEnergyChartData(urlParams);

            dispatch(_this2.actionRequestPayload(_this2.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA, {
                deviceId: urlParams.deviceId,
                dataKey: 'chart',
                isLoading: true
            }, controlModel));
            dispatch(_this2.actionRequest(_this2.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA, true, _this2));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this2.mapDeviceEnergyChartDataToClient(serverResponse, params);
                dispatch(_this2.actionGetDeviceEnergyChartData(_this2, { modelClient, model: controlModel }));
                dispatch(_this2.actionGetDeviceEnergyChartData(_this2, { modelClient, model: _this2 }));
            }).catch(function (error) {
                _this2.catchRequest(_this2, dispatch, failAction)(error);
                dispatch(_this2.actionRequestPayload(_this2.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA, {
                    deviceId: urlParams.deviceId,
                    dataKey: 'chart',
                    isLoading: false
                }, controlModel));
                dispatch(_this2.actionRequest(_this2.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA, false, _this2));
            });
        })();
    }

    static reduceRequestDeviceEnergyChartData(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                chart: _extends({}, stateModel.chart, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static actionGetDeviceEnergyChartData(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_DEVICE_ENERGY_CHART_DATA,
                payload
            });
        };
    }

    static mapDeviceEnergyChartDataToClient(serverResponse, params) {
        const { chart } = this.create();
        let modelData = { chart };
        if (!serverResponse) {
            return modelData;
        }

        const serverModel = this.mapDeviceEnergyChartDataToServer(params);
        const { from, to, scale, type } = serverModel.urlParams;
        convertServerDataToModelData(modelData, from, to, scale, type, serverResponse.sum);
        modelData.chart.isLoading = false;
        modelData.deviceId = serverModel.urlParams.deviceId;

        return modelData;
    }

    static mapDeviceEnergyChartDataToServer(clientModel) {
        if (super.isEmpty(clientModel) || !clientModel.type || !clientModel.to || !clientModel.from) {
            return {
                urlParams: {}
            };
        }

        const from = dateToTst(dateToMomentDate(clientModel.from));
        const to = dateToTst(dateToMomentDate(clientModel.to)) + 1;
        const scale = 50;
        let delta = (to - from) / (scale - 2);

        return {
            urlParams: {
                //filterout: 'duplicate', 
                aggr: 'sum', // is to get the same kind of format as for cost model
                from: from - delta,
                to,
                scale: scale,
                interpolate: 0,
                type: clientModel.type,
                deviceId: clientModel.deviceId
            }
        };
    }

    static reduceGetDeviceEnergyChartData(stateModel, action) {
        const { modelClient, model } = action.payload;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }

    //endregion
    //region api get device status

    static apiGetDeviceStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this3 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this3.mapDeviceStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDeviceStatus(urlParams);

            dispatch(_this3.actionRequestPayload(_this3.TYPE_REQUEST_DEVICE_STATUS, {
                deviceId: urlParams.deviceId,
                dataKey: 'status',
                isLoading: true
            }, controlModel));
            dispatch(_this3.actionRequest(_this3.TYPE_REQUEST_DEVICE_STATUS, true, _this3));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processGetDeviceStatus(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapDeviceStatusToServer(params);
        const modelClient = this.mapDeviceStatusToClient(serverResponse, serverModel.urlParams.deviceId);
        dispatch(this.actionGetDeviceStatus(this, { modelClient, model: controlModel }));
        dispatch(this.actionGetDeviceStatus(this, { modelClient, model: this }));
    }

    static requestGetDeviceStatus(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapDeviceStatusToServer(params);
        const { urlParams } = serverModel;
        dispatch(this.actionRequestPayload(this.TYPE_REQUEST_DEVICE_STATUS, {
            deviceId: urlParams.deviceId,
            dataKey: 'status',
            isLoading: false
        }, controlModel));
        dispatch(this.actionRequest(this.TYPE_REQUEST_DEVICE_STATUS, false, this));
    }

    static reduceRequestGetDeviceStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                status: _extends({}, stateModel.status, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapDeviceStatusToClient(serverModel, deviceId) {
        if (!serverModel) {
            return {
                status: {}
            };
        }

        const statusInfo = serverModel;
        const { className, text, color } = getInfoByStatus(statusInfo.Ch && statusInfo.Ch.value);
        return {
            deviceId,
            status: {
                isLoading: false,
                Ch: statusInfo.Ch,
                className,
                text,
                color
            }
        };
    }

    static mapDeviceStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {
                deviceId: clientModel.deviceId
            }
        };
    }

    static actionGetDeviceStatus(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_DEVICE_STATUS,
                payload
            });
        };
    }

    static reduceGetDeviceStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            status
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                status
            })
        };
    }

    //endregion
    //region api get device power

    static apiGetDevicePower(clientApiMethod, params = {}, dispatch, failAction) {
        var _this4 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this4.mapDevicePowerToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDevicePower(urlParams);

            dispatch(_this4.actionRequestPayload(_this4.TYPE_REQUEST_DEVICE_POWER, {
                deviceId: urlParams.deviceId,
                dataKey: 'power',
                isLoading: true
            }, controlModel));
            dispatch(_this4.actionRequest(_this4.TYPE_REQUEST_DEVICE_POWER, true, _this4));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processGetDevicePower(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapDevicePowerToServer(params);
        const modelClient = this.mapDevicePowerToClient(serverResponse, serverModel.urlParams.deviceId);
        dispatch(this.actionGetDevicePower(this, { modelClient, model: controlModel }));
        dispatch(this.actionGetDevicePower(this, { modelClient, model: this }));
    }

    static requestGetDevicePower(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapDevicePowerToServer(params);
        const { urlParams } = serverModel;
        dispatch(this.actionRequestPayload(this.TYPE_REQUEST_DEVICE_POWER, {
            deviceId: urlParams.deviceId,
            dataKey: 'power',
            isLoading: false
        }, controlModel));
        dispatch(this.actionRequest(this.TYPE_REQUEST_DEVICE_POWER, false, this));
    }

    static reduceRequestGetDevicePower(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                power: _extends({}, stateModel.power, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapDevicePowerToClient(serverModel, deviceId) {
        if (!serverModel) {
            return {
                power: {}
            };
        }

        return {
            deviceId,
            power: {
                isLoading: false,
                status: serverModel.status,
                value: roundNumber(serverModel.P.value),
                time: serverModel.time
            }
        };
    }

    static mapDevicePowerToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {
                deviceId: clientModel.deviceId
            }
        };
    }

    static actionGetDevicePower(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_DEVICE_POWER,
                payload
            });
        };
    }

    static reduceGetDevicePower(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            power
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                power
            })
        };
    }

    //endregion
    //region api get device energy

    static apiGetDeviceEnergy(clientApiMethod, params = {}, dispatch, failAction) {
        var _this5 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this5.mapDeviceEnergyToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDeviceEnergyConsumption(urlParams);

            dispatch(_this5.actionRequestPayload(_this5.TYPE_REQUEST_DEVICE_ENERGY, {
                deviceId: urlParams.deviceId,
                dataKey: 'energy',
                isLoading: true
            }, controlModel));
            dispatch(_this5.actionRequest(_this5.TYPE_REQUEST_DEVICE_ENERGY, true, _this5));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this5.mapDeviceEnergyToClient(serverResponse, params);
                dispatch(_this5.actionGetDeviceEnergy(_this5, { modelClient, model: controlModel }));
                dispatch(_this5.actionGetDeviceEnergy(_this5, { modelClient, model: _this5 }));
            }).catch(function (error) {
                _this5.catchRequest(_this5, dispatch, failAction)(error);
                dispatch(_this5.actionRequestPayload(_this5.TYPE_REQUEST_DEVICE_ENERGY, {
                    deviceId: urlParams.deviceId,
                    dataKey: 'changeStatus',
                    isLoading: false
                }, controlModel));
                dispatch(_this5.actionRequest(_this5.TYPE_REQUEST_DEVICE_ENERGY, false, _this5));
            });
        })();
    }

    static reduceRequestGetDeviceEnergy(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                energy: _extends({}, stateModel.energy, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapDeviceEnergyToClient(serverResponse, params) {
        if (!serverResponse) {
            return {
                energy: {}
            };
        }

        const serverModel = this.mapDeviceEnergyToServer(params);
        // const items = serverResponse[`me/${serverModel.urlParams.deviceId}/app/E_total`];
        const value = calcEnergySum(serverModel.costMode, serverResponse);

        return {
            deviceId: serverModel.urlParams.deviceId,
            energy: {
                isLoading: false,
                value
            }
        };
    }

    static mapDeviceEnergyToServer(clientModel) {
        if (super.isEmpty(clientModel) || !clientModel.to || !clientModel.from) {
            return {
                urlParams: {}
            };
        }

        const from = dateToTst(dateToMomentDate(clientModel.from));
        const to = dateToTst(dateToMomentDate(clientModel.to));

        return {
            urlParams: {
                deviceId: clientModel.deviceId,
                from,
                to,
                scale: 2
            },
            costMode: clientModel.costMode
        };
    }

    static actionGetDeviceEnergy(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_DEVICE_ENERGY,
                payload
            });
        };
    }

    static reduceGetDeviceEnergy(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            energy
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                energy
            })
        };
    }

    //endregion
    //region api set device status

    static apiSetDeviceStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this6 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this6.mapSetDeviceStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.setDeviceStatus(urlParams);

            dispatch(_this6.actionRequestPayload(_this6.TYPE_REQUEST_SET_DEVICE_STATUS, {
                deviceId: urlParams.deviceId,
                dataKey: 'changeStatus',
                isLoading: true
            }, controlModel));
            dispatch(_this6.actionRequest(_this6.TYPE_REQUEST_SET_DEVICE_STATUS, true, _this6));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this6.mapSetDeviceStatusToClient(serverResponse, params);
                dispatch(_this6.actionSetDeviceStatus(_this6, { modelClient, model: controlModel }));
                dispatch(_this6.actionSetDeviceStatus(_this6, { modelClient, model: _this6 }));
            }).catch(function (error) {
                _this6.catchRequest(_this6, dispatch, failAction)(error);
                dispatch(_this6.actionRequestPayload(_this6.TYPE_REQUEST_SET_DEVICE_STATUS, {
                    deviceId: urlParams.deviceId,
                    dataKey: 'changeStatus',
                    isLoading: false
                }, controlModel));
                dispatch(_this6.actionRequest(_this6.TYPE_REQUEST_SET_DEVICE_STATUS, false, _this6));
            });
        })();
    }

    static reduceRequestSetDeviceStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                changeStatus: _extends({}, stateModel.changeStatus, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapSetDeviceStatusToClient(serverResponse, params) {
        if (!serverResponse) {
            return {
                changeStatus: {
                    isLoading: false
                }
            };
        }
        const serverModel = this.mapSetDeviceStatusToServer(params);

        let changedStatusState = {
            deviceId: serverModel.urlParams.deviceId,
            changeStatus: {
                isLoading: false,
                Ch: serverResponse.Ch,
                status: serverResponse.status,
                time: serverResponse.time
            }
        };

        if (serverResponse.status === 'Ack' || serverResponse.status === 'Ok') {
            const { className, text, color } = getInfoByStatus(serverResponse.Ch);
            changedStatusState.status = {
                isLoading: false,
                Ch: serverResponse.Ch,
                className,
                text,
                color
            };
        }

        return changedStatusState;
    }

    static mapSetDeviceStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                urlParams: {}
            };
        }

        return {
            urlParams: {
                deviceId: clientModel.deviceId
            },
            payload: {
                Ch: {
                    value: clientModel.newStatusValue
                }
            }
        };
    }

    static actionSetDeviceStatus(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_SET_DEVICE_STATUS,
                payload
            });
        };
    }

    static reduceSetDeviceStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            changeStatus,
            status
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                changeStatus,
                status
            })
        };
    }
}

deviceModel.MODEL_NAME = 'deviceModel';
deviceModel.TYPE_REQUEST = 'REQUEST_DEVICE';
deviceModel.TYPE_FROM_SERVER = 'GET_DEVICE';
deviceModel.TYPE_CLEAR = 'CLEAR_DEVICE';
deviceModel.TYPE_REQUEST_DEVICE_DATA = 'TYPE_REQUEST_DEVICE_DATA';
deviceModel.TYPE_DEVICE_DATA = 'TYPE_DEVICE_DATA';
deviceModel.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA = 'TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA';
deviceModel.TYPE_DEVICE_ENERGY_CHART_DATA = 'TYPE_DEVICE_ENERGY_CHART_DATA';
deviceModel.TYPE_REQUEST_DEVICE_STATUS = 'TYPE_REQUEST_DEVICE_STATUS';
deviceModel.TYPE_DEVICE_STATUS = 'TYPE_DEVICE_STATUS';
deviceModel.TYPE_REQUEST_DEVICE_POWER = 'TYPE_REQUEST_DEVICE_POWER';
deviceModel.TYPE_DEVICE_POWER = 'TYPE_DEVICE_POWER';
deviceModel.TYPE_REQUEST_DEVICE_ENERGY = 'TYPE_REQUEST_DEVICE_ENERGY..';
deviceModel.TYPE_DEVICE_ENERGY = 'TYPE_DEVICE_ENERGY';
deviceModel.TYPE_REQUEST_SET_DEVICE_STATUS = 'TYPE_REQUEST_SET_DEVICE_STATUS';
deviceModel.TYPE_SET_DEVICE_STATUS = 'TYPE_SET_DEVICE_STATUS';
export { deviceModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/core/device.model.js